import Agents from '@/resources/agents';
import Vue from 'vue';
import SubstationFeederDiagrams from '@/resources/substation-feeder-diagrams';
import RootStateCommit from '@/store/mixins/rootstate-commit';
import normalize from '@/lib/normalize';

const MODULE_NAME = 'agent';
const DEFAULT_STATE = {
  error: '',
  agent: null,
  feederDiagrams: []
};

export default {
  namespaced: true,
  state: { ...DEFAULT_STATE },
  /* eslint no-param-reassign: ["error", { "props": false }] */
  mutations: {
    parseResponseData(state, response) {
      state.agent = normalize(response);
    },
    setFeederDiagrams(state, response) {
      Vue.set(state, 'feederDiagrams', normalize(response));
    },
    setResponseError(state, error) {
      Object.assign(state.error, error);
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE);
    }
  },
  actions: {
    fetchRecord({ commit }, { projectCode, substationCode, code }) {
      const action = Agents({ projectCode, substationCode }).get({ code });

      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      action.then(
        response => {
          commit('parseResponseData', response.data);
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        }
      );

      return action;
    },
    save({ commit }, { projectCode, substationCode, code, data }) {
      const action = Agents({ projectCode, substationCode }).update({ code }, data);

      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      action.then(
        () => {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        () => {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        }
      );

      return action;
    },
    uploadDiagram({ commit }, data) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);

      const {
        projectCode,
        substationCode,
        agentCode,
        diagram_type,
        diagram_file,
        feeder_number
      } = data;

      return SubstationFeederDiagrams({
        projectCode,
        substationCode,
        agentCode
      })
        .save({ diagram_type, diagram_file, feeder_number })
        .then(() => {
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
          return true;
        })
        .catch(error => {
          commit('setResponseError', error);
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);

          return false;
        });
    },
    async removeDiagram({ commit }, data) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);

      const { projectCode, substationCode, agentCode, diagram_type, feeder_number } = data;

      const response = await SubstationFeederDiagrams({
        projectCode,
        substationCode,
        agentCode
      }).delete({ code: feeder_number, diagram_type });

      if (response.status !== 204) {
        commit('setResponseError', response);

        RootStateCommit(commit, 'setResponseError', MODULE_NAME);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);

        return false;
      }

      RootStateCommit(commit, 'stopLoading', MODULE_NAME);

      return true;
    },
    fetchDiagrams({ commit }, data) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);

      const { projectCode, substationCode, agentCode, feeder_number } = data;

      SubstationFeederDiagrams({ projectCode, substationCode, agentCode })
        .get({ code: feeder_number })
        .then(response => {
          commit('setFeederDiagrams', response.data);
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        })
        .catch(error => {
          commit('setResponseError', error);
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        });
    }
  },
  getters: {
    feederDiagrams: state => state.feederDiagrams
  }
};
